import dayjs from 'dayjs';
// This date is used to determine if a document is due for review
export const getReviewDueDateCutoff = () =>
  dayjs().add(30, 'days').endOf('hour');
